module.exports = __webpack_public_path__ + "static/media/DKP.ede49f63.webp";